/**
 * Swym が描画する価格の「JPY 3992」表記を「¥3,992」へ直す。
 *
 * Swym のバリアント選択モーダル（リストに追加）はストアの通貨フォーマットを
 * 使わず「通貨コード + 数値」で価格を出すため、テーマ側で書き換える。
 * 手法は swym-wishlist-label.js（ボタン文言の上書き）と同じ:
 * MutationObserver で Swym の注入を追い、対象テキストだけ差し替える。
 * 書き換え後は正規表現に一致しなくなるため監視ループにはならない。
 */

const PRICE_SELECTOR = '#swym-custom-variant-price';

// "JPY 3992" / "JPY 3,992" / "JPY 3992.00" を許容
const JPY_PATTERN = /^JPY\s*([\d,]+(?:\.\d+)?)$/;

function formatPrices() {
  for (const el of document.querySelectorAll(PRICE_SELECTOR)) {
    const match = el.textContent.trim().match(JPY_PATTERN);
    if (!match) continue;
    const amount = Math.round(parseFloat(match[1].replace(/,/g, '')));
    if (!Number.isFinite(amount)) continue;
    el.textContent = `¥${amount.toLocaleString('ja-JP')}`;
  }
}

let queued = false;
function scheduleFormat() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    formatPrices();
  });
}

formatPrices();
document.addEventListener('DOMContentLoaded', formatPrices);

new MutationObserver(scheduleFormat).observe(document.documentElement, {
  childList: true,
  subtree: true,
  characterData: true,
});

// アプリのスクリプト読み込みが遅れるストアがあるので数回だけ叩き直す。
for (const ms of [300, 800, 1500, 3000, 5000]) {
  setTimeout(formatPrices, ms);
}
